import { render } from "./pageTitle.vue?vue&type=template&id=734f9da0&scoped=true&ts=true"
import script from "./pageTitle.vue?vue&type=script&lang=ts"
export * from "./pageTitle.vue?vue&type=script&lang=ts"

import "./pageTitle.vue?vue&type=style&index=0&id=734f9da0&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734f9da0"]])

export default __exports__